import React from 'react';

import { Box, Text } from '@mantine/core';

type UtilizationRateCellProps = {
  value: number;
};

const colorFormat = (value: number): string => {
  if (value > 0.75) {
    return 'green';
  }

  if (value > 0.5) {
    return 'yellow';
  }

  return 'red';
};

const UtilizationRateCell = ({ value }: UtilizationRateCellProps): JSX.Element => {
  const color = colorFormat(value);
  const formattedValue = (value * 100).toFixed(1);

  return (
    <Box display='flex' sx={{ justifyContent: 'center' }}>
      <Text color={color}>{formattedValue}%</Text>
    </Box>
  );
};

export default UtilizationRateCell;
